import { Component } from '@angular/core';

import { CerSessionService } from 'src/cer/cer-session/cer-session.service';

import { CerAppApplicationInsightsService } from 'src/cer-app/cer-app-application-insights/cer-app-application-insights.service';
import { CerAppRealtimeService } from 'src/cer-app/cer-app-realtime/cer-app-realtime.service';

import { VoucherSidenavStateService } from '@app/voucher/voucher-sidenav-state.service';
import { CerSessionUserNavigationService } from '@cer/cer-session/cer-session-user-navigation.service';
import { CerSessionUserService } from '@cer/cer-session/cer-session-user.service';
import { CerSessionEnvironmentService } from '@cer/cer-session/cer-session-environment.service';

@Component({
  selector: 'cer-app-layout-main-router',
  templateUrl: './cer-app-layout-main-router.component.html',
  styleUrls: ['cer-app-layout-main-router.component.css'],
  providers: [VoucherSidenavStateService]
})

export class CerAppLayoutMainRouterComponent {
 
  constructor(
    /* Injected here because app depends on it in general as a shared server */  
    private sessionService: CerSessionService,
    private sessionEnvironmentService: CerSessionEnvironmentService,
    private sessionUserService: CerSessionUserService,
    private sessionUserNavigationService: CerSessionUserNavigationService,
    private realTimeService: CerAppRealtimeService,
    private voucherSidenavStateService: VoucherSidenavStateService, 
    private appInsightsService: CerAppApplicationInsightsService ) {
  }
}


